import { SortItem } from "@models/ss-api/responses/member.dashboard.license.response";
import { ISortable } from '../../helpers/sort';

export class VideoCardBenchmarkItemArray extends Array<VideoCardBenchmarkItem> implements ISortable {

    public LastSort = new SortItem;
    
    constructor(...items:VideoCardBenchmarkItem[]) {
        super(...items);
        Object.setPrototypeOf(this, VideoCardBenchmarkItemArray.prototype);
    }

    public static FixDates(items: VideoCardBenchmarkItemArray) {
        items.forEach(x => VideoCardBenchmarkItem.FixDates(x));
    } 
}

export class VideoCardBenchmarkItem  {
    VideoCardBenchmarkID: number;
    VideoCardName: string;
    AlternateName1: string;
    AlternateName2: string;
    AlternateName3: string;
    AlternateName4: string;
    AlternateName5: string;
    AlternateName6: string;
    BenchmarkScore: number;
    LicenseCount: number;
    DateTimeCreated?: Date;
    DateTimeUpdated?: Date; 

    public static FixDates(item: VideoCardBenchmarkItem) {
        if (item.DateTimeCreated != null && item.DateTimeCreated != undefined)
            item.DateTimeCreated = new Date(item.DateTimeCreated);

        if (item.DateTimeUpdated != null && item.DateTimeUpdated != undefined)
            item.DateTimeUpdated = new Date(item.DateTimeUpdated);

    }    
}
